import { render, staticRenderFns } from "./activity-form-multi-choice-preview.vue?vue&type=template&id=cd40a17c&scoped=true&"
import script from "./activity-form-multi-choice-preview.vue?vue&type=script&lang=js&"
export * from "./activity-form-multi-choice-preview.vue?vue&type=script&lang=js&"
import style0 from "./activity-form-multi-choice-preview.vue?vue&type=style&index=0&id=cd40a17c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd40a17c",
  null
  
)

component.options.__file = "activity-form-multi-choice-preview.vue"
export default component.exports